export default "<ul class=\"search-suggest-list\"></ul>\n"